module.exports = {"532930101":"茈碧湖镇","532930102":"邓川镇","532930103":"右所镇","532930104":"三营镇","532930105":"凤羽镇","532930106":"乔后镇","532930201":"牛街乡","532930202":"炼铁乡","532930203":"西山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532930.json
// module id = 2793
// module chunks = 0